export default "/images/pr-img-3.png?455e64158debc091d8946367213aa70b";